import { render, staticRenderFns } from "./AluminiStudentView.vue?vue&type=template&id=139dece8&scoped=true&"
import script from "./AluminiStudentView.vue?vue&type=script&lang=js&"
export * from "./AluminiStudentView.vue?vue&type=script&lang=js&"
import style0 from "./AluminiStudentView.vue?vue&type=style&index=0&id=139dece8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139dece8",
  null
  
)

export default component.exports